import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.797 17.925h1.334s.4-.064.6-.254.2-.571.2-.571 0-1.65.8-1.903 1.868 1.65 2.935 2.347c.8.57 1.4.444 1.4.444l2.935-.063s1.534-.064.8-1.269c-.066-.063-.4-.825-2.2-2.41-1.868-1.65-1.601-1.332.6-4.187 1.334-1.712 1.867-2.727 1.734-3.234-.134-.444-1.134-.318-1.134-.318h-3.335s-.267-.063-.4.064a.7.7 0 0 0-.267.317s-.533 1.332-1.2 2.474c-1.467 2.347-2.068 2.473-2.268 2.347-.533-.318-.4-1.396-.4-2.094 0-2.283.4-3.234-.733-3.488-.334-.064-.6-.127-1.534-.127-1.201 0-2.201 0-2.735.254-.4.19-.667.57-.467.57s.734.127 1 .445c.267.57.267 1.522.267 1.522s.2 2.727-.466 3.044c-.467.254-1.068-.253-2.401-2.41-.667-1.078-1.2-2.347-1.2-2.347s-.068-.253-.268-.38-.533-.19-.533-.19H1.726s-.467 0-.667.19c-.133.19 0 .507 0 .507s2.468 5.455 5.27 8.246c2.6 2.664 5.468 2.474 5.468 2.474",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "vk"}) } }